/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 ListItemText — NS/Tractie component overrides.
// All MUI v4 style classes are declared explicitly (no implicit inheritance on MUI defaults).
// Tractie deviations: marginTop/Bottom 4 (MUI default) blijft, inset wijzigt naar 56 (accept),
// dense leeg gehouden (geen padding shift, ListItem.dense doet padding al).

export const MuiListItemTextLightOverrides = {
  root: {
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
  },

  multiline: {
    marginTop: 6,
    marginBottom: 6,
  },

  // Dense modifier — leeg om MUI v4 surface contract te respecteren. ListItem.dense
  // regelt padding van het hele item; ListItemText.dense voegt geen extra spacing toe.
  dense: {},

  inset: {
    paddingLeft: 56,
  },

  // primary / secondary worden door MUI v4 als wrappers op Typography toegepast.
  // Color/typography volgen het ouder-Typography theme (palette.text.*); geen NS-deviation.
  primary: {},

  secondary: {},
} as const;

// Dark variant — geen mode-specifieke overrides; layout/spacing zijn modes-agnostisch.
export const MuiListItemTextDarkOverrides = {
  ...MuiListItemTextLightOverrides,
} as const;
